import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';
import cN from 'classnames';
import parse from 'html-react-parser';
import Meals from './Meals';
interface I_Props {
    toggleLightBox: (reqDayID: number, reqPOIID: string) => void;
    mealType: Array<number>;
}

const ReduceMode: React.FC<I_Props> = ({ toggleLightBox, mealType }) => {
    const ItineraryInfo = useSelector((store: RootState) => store.itinerariesReducer);
    const DailyList = ItineraryInfo.DailyList;
    return (
        <div className={styles.reducedMode}>
            <div className={styles.dayTripWrapperReduce}>
                <div className={styles.titleBar}>
                    <div>天數</div>
                    <div>行程</div>
                    <div>景點</div>
                    <div>餐食</div>
                    <div>旅館</div>
                </div>
                {DailyList.map((dailyItem) => (
                    <div key={`${dailyItem.DayID}reduce`} className={styles.dayTripReduce}>
                        <div>
                            <div className={styles.imgDayReduce}>
                                <div>DAY</div>
                                <div>
                                    {dailyItem.Day}
                                </div>
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: dailyItem.TravelPoint! }} />
                        <div>
                            {dailyItem.AttractionsList.map((item: any) => (
                                <div
                                    key={`${item.AttractionsID}reduce`}
                                    className={cN(item.AttractionsID && styles.trigger)}
                                    onClick={() =>
                                        toggleLightBox(dailyItem.DayID, item.AttractionsID)
                                    }
                                >
                                    {item.Name}
                                </div>
                            ))}
                        </div>
                        <div>
                            {mealType.map((type, idx) => {
                                return (
                                    <Meals
                                        key={`${type}`}
                                        mealList={dailyItem.MealList}
                                        mealTypes={type}
                                        DayID={dailyItem.DayID}
                                        toggleLightBox={toggleLightBox}
                                    />
                                );
                            })}
                        </div>
                        <div>
                            {dailyItem.HotelList.map((item: any, idx: any) =>
                                item.HotelID !== null ? (
                                    <span key={item.HotelID}>
                                        <span
                                            className={styles.trigger}
                                            onClick={() =>
                                                toggleLightBox(dailyItem.DayID, item.HotelID)
                                            }
                                        >
                                            {item.Name}
                                        </span>
                                        {idx === dailyItem.HotelList.length - 1 ? '' : ' 或 '}
                                    </span>
                                ) : (
                                    <span>{item.Name}</span>
                                )
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReduceMode;
